export enum ImportType {
  EnableFeature = 'EnableFeatureForIds',
  DisableFeature = 'DisableFeatureForIds',
}
